import { useRef, useState } from "react";

import uploadIcon from "../assets/upload-green-icon.svg";
import eyeIcon from "../assets/eye-icon.svg";
import blackDeleteIcon from "../assets/black-delete-icon.svg";
import saveIcon from "../assets/save-icon.svg";

const InvestigationDocumentsFormAi = () => {
  const [documentName, setDocumentName] = useState("");
  const [documentsData, setDocumentsData] = useState([]);
  const nextIdRef = useRef(1);

  const handleAdd = () => {
    const trimmedName = documentName.trim();
    if (!trimmedName) return;

    const isAlreadyMapped = documentsData.some(
      (item) => item.documentName === trimmedName,
    );
    if (isAlreadyMapped) {
      setDocumentName("");
      return;
    }

    setDocumentsData((prev) => [
      ...prev,
      {
        id: nextIdRef.current,
        documentName: trimmedName,
        documentSubType: "",
        file: null,
        fileUrl: null,
      },
    ]);
    nextIdRef.current += 1;
    setDocumentName("");
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleAdd();
    }
  };

  const handleFileChange = (id, file) => {
    if (!file) return;

    setDocumentsData((prev) =>
      prev.map((item) => {
        if (item.id !== id) return item;
        if (item.fileUrl) URL.revokeObjectURL(item.fileUrl);
        return { ...item, file, fileUrl: URL.createObjectURL(file) };
      }),
    );
  };

  const handleDrop = (id, e) => {
    e.preventDefault();
    const file = e.dataTransfer.files?.[0];
    handleFileChange(id, file);
  };

  const handleDelete = (id) => {
    setDocumentsData((prev) => {
      const item = prev.find((doc) => doc.id === id);
      if (item?.fileUrl) URL.revokeObjectURL(item.fileUrl);
      return prev.filter((doc) => doc.id !== id);
    });
  };

  const openDocument = (item) => {
    if (!item?.fileUrl) return;
    window.open(item.fileUrl, "_blank", "noopener,noreferrer");
  };

  return (
    <div className="w-full">
      <div className="w-full h-0 border border-solid border-[#00000010] bg-[#00000010]" />{" "}
      <div className="flex items-center justify-between pt-[30px]">
        <div className="w-[24%]">
          <div className="relative w-full min-w-0 box-border overflow-hidden h-[52px] rounded-[42px] border border-solid border-[#D9D9D9] bg-transparent px-[32px] flex items-center">
            <input
              type="text"
              placeholder="Document Name"
              value={documentName}
              onChange={(e) => setDocumentName(e.target.value)}
              onKeyDown={handleKeyDown}
              className="w-full min-w-0 bg-transparent border-none outline-none focus:outline-none focus:ring-0 focus:border-none shadow-none font-lufga font-normal text-[14px] leading-[12px] tracking-[-0.03em] text-[#1A1A1A] placeholder:text-[#8B8B8B]"
            />
          </div>
        </div>
        <div className="flex items-center gap-[8px]">
          <button
            type="button"
            className="w-[88px] h-[52px] 2xl:w-[88px] 2xl:h-[52px] rounded-[42px] border border-solid border-[#D9D9D9] bg-transparent flex justify-center items-center font-lufga font-normal text-[14px] leading-[12px] tracking-[-0.03em] text-[#8B8B8B]"
            onClick={handleAdd}
          >
            ADD
          </button>

          <button
            type="button"
            className="w-[198px] h-[52px] rounded-[42px] border border-none bg-black flex items-center justify-center gap-[10px] uppercase font-lufga font-normal text-[12px] leading-[12px] tracking-[-0.35px] text-[#68FF9F]"
          >
            ADD OTHER DOCUMENTS
            <span className="text-[30px] leading-none mb-[2px]">+</span>
          </button>
        </div>
      </div>
      <div className="pt-[52px]">
        <div className="grid xl:grid-cols-[1fr_24fr_8fr_1.5fr] xl:gap-x-[19px]  3xl:gap-x-[140px] items-start">
          {" "}
          <div className="font-lufga font-normal text-[14px] leading-[12px] tracking-[-0.03em] text-[#5AC69F]">
            No.
          </div>
          <div className="font-lufga font-normal text-[14px] leading-[12px] tracking-[-0.03em] text-[#5AC69F]">
            Name
          </div>
          <div className="3xl:pl-11 font-lufga font-normal text-[14px] leading-[12px] tracking-[-0.03em] text-[#5AC69F]">
            Upload
          </div>
          <div className="font-lufga font-normal text-[14px] leading-[12px] tracking-[-0.03em] text-[#5AC69F]">
            Action
          </div>
        </div>

        <div className="mt-[34px] flex flex-col gap-y-[34px]">
          {documentsData.map((item, index) => (
            <div
              key={item.id}
              className="grid xl:grid-cols-[1fr_24fr_8fr_1.5fr] xl:gap-x-[19px]  3xl:gap-x-[140px] items-start"
            >
              <div className="font-lufga font-normal text-[14px] leading-[100%] tracking-[-0.03em] text-[#000000]">
                {index + 1}.{" "}
              </div>

              <div className="truncate font-lufga font-normal text-[14px] leading-[100%] tracking-[-0.03em] text-[#000000]">
                {`${item?.documentSubType ? item?.documentSubType + "-" : ""} ${item?.documentName || "--"}`}
              </div>

              <div
                className="flex items-center gap-[6px] min-w-0"
                onDragOver={(e) => e.preventDefault()}
                onDrop={(e) => handleDrop(item.id, e)}
              >
                <label
                  htmlFor={`investigation-file-${item.id}`}
                  className="flex items-center gap-[6px] min-w-0 cursor-pointer"
                >
                  <img src={uploadIcon} alt="upload" className="shrink-0" />
                  <span className="underline font-lufga font-normal text-[14px] leading-[100%] tracking-[-0.03em] text-[#000000] truncate">
                    {item.file?.name || "Drag your file here or Browse"}
                  </span>
                </label>
                <img
                  src={eyeIcon}
                  alt="info"
                  className="shrink-0 cursor-pointer"
                  onClick={() => openDocument(item)}
                />
                <input
                  id={`investigation-file-${item.id}`}
                  type="file"
                  className="hidden"
                  accept=".pdf,.png,.jpg,.jpeg"
                  onChange={(e) => {
                    handleFileChange(item.id, e.target.files?.[0]);
                    e.target.value = "";
                  }}
                />
              </div>

              <button
                type="button"
                onClick={() => handleDelete(item.id)}
                className=" flex items-center justify-self-center bg-transparent border-none cursor-pointer p-0"
              >
                <img src={blackDeleteIcon} alt="delete icon" />
              </button>
            </div>
          ))}
        </div>
      </div>
      <div className="flex justify-end mt-[12px]">
        <button
          type="button"
          className="w-[170px] h-[74px] xl:w-[94.97px] xl:h-[40.97px]  2xl:w-[94.97px] 2xl:h-[40.97px] border border-none rounded-full bg-black flex justify-center items-center gap-[8px] font-lufga text-[14px] text-[#68FF9F] font-normal"
        >
          SAVE
          <img src={saveIcon} alt="save" className="pl-[16px]" />
        </button>
      </div>
    </div>
  );
};

export default InvestigationDocumentsFormAi;
